import { Wabtec, google } from './build/RawTrackData.js';

// Create aliases for deeply nested namespaces.
import Investigations = Wabtec.DataPlatform.Common.Investigations;

// Create aliases for deeply nested classes and interfaces within namespaces.
import RawTrackData = Investigations.RawTrackData;
import IRawTrackData = Investigations.IRawTrackData;
import IRawTrackEntry = Investigations.IRawTrackEntry;
import IRawNameToId = Investigations.IRawNameToId;
import IRawIdToIdAndName = Investigations.IRawIdToIdAndName;
import ISelfTestFailure = Investigations.ISelfTestFailure;
import ITimestamp = google.protobuf.ITimestamp;

// Export only aliases of classes and interfaces to avoid the use of namespaces.
export {
  RawTrackData,
  IRawTrackData,
  IRawTrackEntry,
  IRawNameToId,
  IRawIdToIdAndName,
  ISelfTestFailure,
  ITimestamp,
};
